/**
 * 관리자 "게시판 권한 관리" 목록을 사용자 헤더 메뉴 구조와 동일하게 보이도록 하는 매핑.
 *
 * key: 관리자 데이터의 board.name (실제 내부 이름)
 * value:
 *   - label : 헤더에 노출되는 표시명 (예: Organ -> "질환 카테고리")
 *   - parent: 헤더에서 속한 상위 그룹 (예: "회원공간"). 최상위면 생략.
 *   - order : 헤더 노출 순서
 *
 * 헤더 구조 출처: src/component/header/Header.tsx (하드코딩된 네비게이션)
 * ※ 갤러리/진단오류제보게시판/Q&A/자료실 및 게시판은 게시판 권한 관리 대상이 아니라 목록에 나타나지 않음.
 */
export interface BoardHeaderInfo {
  label: string;
  parent?: string;
  order: number;
}

export const BOARD_HEADER_MAP: Record<string, BoardHeaderInfo> = {
  Organ: { label: "질환 카테고리", order: 1 },

  // 회원공간 그룹
  "소아병리연구회 집담회": { label: "소아병리연구회 집담회", parent: "회원공간", order: 2 },
  "학생 병원 병리학 실습": { label: "학생 병원 병리학 실습", parent: "회원공간", order: 3 },
  Consultation: { label: "Consultation/Discussion", parent: "회원공간", order: 4 },
  "전자현미경 연구회": { label: "전자현미경 연구회", parent: "회원공간", order: 5 },
  "학술강좌": { label: "학술강좌", parent: "회원공간", order: 6 },

  // 최상위
  Placenta: { label: "Placenta", order: 7 },
  Muscle: { label: "Muscle", order: 8 },
  Research: { label: "Research", order: 9 },
};

/**
 * board.name 으로 헤더 표시 정보를 반환. 매핑에 없으면 원본 이름을 그대로 쓰고 맨 뒤로 정렬.
 */
export const getBoardHeaderInfo = (name: string): BoardHeaderInfo =>
  BOARD_HEADER_MAP[name] ?? { label: name, order: 999 };
